import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TProvider, TProviderPayloadRequest, TProviderResponse, adaptProviderFromResponse, adaptProviderToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER } from '../../backend-paths';


export const providerCreateApi = createAsyncThunk(
	`POST/${BACKEND_ADMIN_PROVIDER}`,
	(payload: TProviderPayloadRequest, thunkApi) => {
		const dataRequest = adaptProviderToRequest(payload);

		return HttpService.post<TProviderResponse>(BACKEND_ADMIN_PROVIDER, dataRequest).then(result => {
			return adaptProviderFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProvider> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerCreateSlice = createSlice({
	name: 'providerCreateSlice',
	initialState,
	reducers: {
		clearProviderCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[providerCreateApi.fulfilled.type]: (state, action: PayloadAction<TProvider>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useProviderCreateSelector = () => useAppSelector(state => state[providerCreateSlice.name]);

export const { clearProviderCreate } = providerCreateSlice.actions;
